import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { ButtonLink } from '@dtx-company/inter-app/src/utils/links'
import { CAREERS_JOIN_FLOWCODE_URL } from '../../constants/flowcode'
import { FC } from 'react'
import { Image } from '@dtx-company/shared-components/src/components/atoms/Image/index'
import { TeamContainerProps, TeamMemberType } from './Team.types'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { theme } from '@dtx-company/shared-components/src'
import styled from 'styled-components'

const Avatar = styled(Image)`
  overflow: hidden;
  margin-bottom: 22px;
  border-radius: 50%;
  img {
    transform-origin: 50% 20%;
    transition: transform 3s ease-in-out;
    filter: grayscale(100%);
  }
  :hover img {
    transform: scale(1.04);
    filter: none;
  }
`

const StyledButtonLink = styled(ButtonLink)`
  &:hover {
    background-color: black;
    border-color: black;
  }
`

export const TeamContainer: FC<TeamContainerProps> = props => {
  const { team, heading, subheading } = props.data

  return (
    <>
      <Box
        maxWidth={['300px', '450px', '600px']}
        flexDirection="column"
        m="0 auto"
        alignItems="center"
      >
        <Text
          variant={['display/large', 'display/large', 'display/xLarge']}
          fontWeight={['normal', 'normal', 'bold']}
          mt={['40px', '40px', '80px']}
          textAlign="center"
        >
          {heading}
        </Text>
        <Text variant="body/large" mt="20px" mb="32px" textAlign="center">
          {subheading}
        </Text>
        <StyledButtonLink
          sizeVariant="large"
          width={['90vw', 'fit-content', 'fit-content']}
          border="none"
          maxWidth={['90vw', '280px', '280px']}
          padding="0px 16px"
          backgroundColor={theme.colors.primary.flowBlue}
          href={CAREERS_JOIN_FLOWCODE_URL}
        >
          View job openings
        </StyledButtonLink>
      </Box>
      <Box flexWrap="wrap" justifyContent="center" maxWidth="1440px" m="36px auto">
        {team.map((m: TeamMemberType, i) => (
          <Box
            key={i}
            width={['70%', '60%', '20%']}
            m="24px"
            mb={['40px', '40px', '24px']}
            flexDirection="column"
          >
            <Avatar src={m.avatar} alt={m.name} />
            <Text variant="body/medium" fontWeight="bold" color="primary.flowBlue" mb="3px">
              {m.name.toLowerCase().replace(/\b\w/g, l => l.toUpperCase())}
            </Text>
            <Text variant="body/medium" mb="4px" color="#111">
              {m.position}
            </Text>
            {m?.hometown && (
              <Text variant="general/captionAndLabel" color="#636565">
                Hometown: {m.hometown}
              </Text>
            )}
            {m?.education && (
              <Text variant="general/captionAndLabel" color="#636565">
                Education: {m.education}
              </Text>
            )}
            {m?.previously && (
              <Text variant="general/captionAndLabel" color="#636565">
                Previously: {m.previously}
              </Text>
            )}
            {m?.dtc && (
              <Text variant="general/captionAndLabel" color="#636565">
                Dtc brand obsession: {m.dtc}
              </Text>
            )}
            {m?.freeTime && (
              <Text variant="general/captionAndLabel" color="#636565">
                In my free time: {m.freeTime}
              </Text>
            )}
          </Box>
        ))}
      </Box>
    </>
  )
}
